<template>
  <v-btn
    id="import_button"
    block
    dark
    large
    color="primaryButton"
    :disabled="!core.enableIdentify"
    @click="
      core.import.reset_import_modal();
      core.import.show_import_modal();
    "
    class="tour_map_step3"
  >
    <v-icon>mdi-file-upload-outline</v-icon>
    <!-- <span v-if="core.tableWidthSize != 'xs'">{{ $t("common.import") }}</span> -->
    <span>{{ $t("common.import") }}</span>
  </v-btn>
</template>

<script>
export default {
  props: ["core"],
};
</script>